import styled from 'styled-components';

import { SLIDER_HEIGHT } from '@src/styles/dimensions';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
  margin-top: ${({ theme }) => theme.spacing4}px;
`;

export const Slides = styled.div`
  width: 100%;
  height: ${SLIDER_HEIGHT}px;
  overflow: hidden;
  display: flex;
  flex: 1 0 ${SLIDER_HEIGHT}px;
`;

export const Slide = styled.div<{ isActive: boolean; sideMargin?: number; overflow?: string }>`
  width: 100%;
  flex: 1 0 0;
  display: ${({ isActive }) => (isActive ? 'flex' : 'none')};
  overflow: ${({ overflow }) => (overflow ? overflow : 'hidden')};
  flex-direction: column;
  margin: ${({ sideMargin }) => (sideMargin ? `0 ${sideMargin}px` : '0px')};
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const PageItem = styled.div<{ isActive: boolean }>`
  width: 8px;
  height: 8px;

  background: ${props => (props.isActive ? props.theme.colors.gray['100'] : 'inherit')};
  border: 1px solid ${props => (props.isActive ? props.theme.colors.gray['100'] : props.theme.colors.gray['070'])};
  border-radius: 50%;
  margin: 0 ${({ theme }) => theme.spacing2}px;
`;

export const PageButton = styled.button.attrs(() => ({ type: 'button' }))`
  height: auto;
  padding: 0 1px;
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
